<section class="relative p-6 bg-gray-50 rounded-2xl shadow-inner border border-gray-200">

  <h2 class="text-2xl font-bold text-[#181F38]">Gestión de Mensajes</h2>
  <div *ngIf="!isLoading" class="flex justify-between items-center mb-4">

    <section class="w-full flex flex-col justify-between items-center pt-3 px-8">

      <section class="flex items-center justify-between w-full">

        <app-breadcrumb></app-breadcrumb>


        <app-buttons [buttons]="buttons" [showButton]="true" (ejecutarAccion)="executeButtons($event)">
        </app-buttons>
      </section>

      <app-filters *ngIf="showFilters" #filtrosComponent [filtrosConfig]="filtrosConfig" class="w-[100%]"
        (ejecutarAccion)="getDataNewFilter($event)">
      </app-filters>

    </section>

  </div>

  <div *ngIf="!isLoading" class="overflow-x-auto overflow-y-auto max-h-[550px]">
    <table mat-table [dataSource]="dataSource" matSort class="min-w-full bg-white rounded-lg shadow-sm ">

      <!-- telefono -->
      <ng-container matColumnDef="telefono">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Teléfono</th>
        <td mat-cell *matCellDef="let element">
          {{ element.telefono | slice:2 }}
        </td>

      </ng-container>


      <!-- idPaciente -->
      <ng-container matColumnDef="idPaciente">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Id Paciente</th>
        <td mat-cell *matCellDef="let element">{{ element.nDocumento[0] }}</td>
      </ng-container>

      <!-- nombresPaciente -->
      <ng-container matColumnDef="nombresPaciente">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombres Paciente</th>
        <td mat-cell *matCellDef="let element">{{ element.nombre[0] }}</td>
      </ng-container>

      <!-- EPS -->
      <ng-container matColumnDef="eps">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>EPS</th>
        <td mat-cell *matCellDef="let element">{{ element.eps }}</td>
      </ng-container>

      <ng-container matColumnDef="habeasData">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>HabeasData</th>

        <td mat-cell *matCellDef="let element" class="text-center">
          <mat-icon translate="no" [ngStyle]="{ color: element.habeasData == '1' ? '#16a34a' : '' }"
            class="flex justify-center items-center">
            {{ element.habeasData == '1' ? 'check_box' : 'check_box_outline_blank' }}
          </mat-icon>

        </td>
      </ng-container>

      <ng-container matColumnDef="mensajeBienvenida">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Msg Lanzamiento</th>

        <td mat-cell *matCellDef="let element" class="text-center">
          <mat-icon translate="no" [ngStyle]="{ color: element.mensajeBienvenida == '1' ? '#16a34a' : '' }"
            class="flex justify-center items-center">
            {{ element.mensajeBienvenida == '1' ? 'check_box' : 'check_box_outline_blank' }}
          </mat-icon>

        </td>
      </ng-container>




      <ng-container matColumnDef="tratamientodatos">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Habeas Data</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.tratamientodatos; else sinDato">
            <button mat-stroked-button color="primary" (click)="verTabla('tratamientodatos', element.tratamientodatos)">
              Ver Detalle
            </button>
          </ng-container>
          <ng-template #sinDato>—</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="mensajeDisparador">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Msg Inicial</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.mensajeDisparador; else sinDato">
            <button mat-stroked-button color="primary"
              (click)="verTabla('mensajeDisparador', element.mensajeDisparador)">
              Ver Detalle
            </button>
          </ng-container>
          <ng-template #sinDato>—</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="tratamientoDatosMenorEdad">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Habeas Menor</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.tratamientoDatosMenorEdad; else sinDato">
            <button mat-stroked-button color="primary"
              (click)="verTabla('tratamientoDatosMenorEdad', element.tratamientoDatosMenorEdad)">
              Ver Detalle
            </button>
          </ng-container>
          <ng-template #sinDato>—</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="estadovalidacionpaciente1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Est Vali Paciente</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.estadovalidacionpaciente1; else sinDato">
            <button mat-stroked-button color="primary"
              (click)="verTabla('estadovalidacionpaciente1', element.estadovalidacionpaciente1)">
              Ver Detalle
            </button>
          </ng-container>
          <ng-template #sinDato>—</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="estadovalidacionpaciente2">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Est Vali IPS</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.estadovalidacionpaciente2; else sinDato">
            <button mat-stroked-button color="primary"
              (click)="verTabla('estadovalidacionpaciente2', element.estadovalidacionpaciente2)">
              Ver Detalle
            </button>
          </ng-container>
          <ng-template #sinDato>—</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="procesoEntrega">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Proceso Entrega</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.procesoEntrega; else sinDato">
            <button mat-stroked-button color="primary" (click)="verTabla('procesoEntrega', element.procesoEntrega)">
              Ver Detalle
            </button>
          </ng-container>
          <ng-template #sinDato>—</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="entregaExitosa">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Entrega Exitosa</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.entregaExitosa; else sinDato">
            <button mat-stroked-button color="primary" (click)="verTabla('entregaExitosa', element.entregaExitosa)">
              Ver Detalle
            </button>
          </ng-container>
          <ng-template #sinDato>—</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="respuestaCicloUno">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Respuesta Ciclo Uno</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.respuestaCicloUno; else sinDato">
            <button mat-stroked-button color="primary"
              (click)="verTabla('respuestaCicloUno', element.respuestaCicloUno)">
              Ver Detalle
            </button>
          </ng-container>
          <ng-template #sinDato>—</ng-template>
        </td>
      </ng-container>




      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef>Chat</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="primary" (click)="openDetalle(element)">
            <mat-icon translate="no">chat</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header "></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
  <div *ngIf="isLoading" class="absolute inset-0 z-50 flex items-center justify-center bg-white/70 backdrop-blur-sm h-96">
    <app-loading></app-loading>
  </div>
</section>